/**************************************************************************************************/
/*   File: /src/app/stores/actions/router/actions.ts                                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NavigationExtras } from '@angular/router';
import { Action } from '@ngrx/store';

// Use 'enum' to be registered as a map later
/**
 * The router actions type
 */
export enum RouterActionTypes {
  Go = '[Router] Go',
  Back = '[Router] Back',
  Forward = '[Router] Forward'
}

/**
 * The go action
 */
export class Go implements Action {
  /**
   * The type
   */
  readonly type = RouterActionTypes.Go;

  /**
   * The constructor
   * @param payload The payloadrequiredfor routing
   */
  constructor(
    public payload: {
      path: any[];
      query?: object;
      extras?: NavigationExtras;
    }
  ) {}
}

/**
 * The back action
 */
export class Back implements Action {
  /**
   * The type
   */
  readonly type = RouterActionTypes.Back;
}

/**
 * The forward action
 */
export class Forward implements Action {
  /**
   * The type
   */
  readonly type = RouterActionTypes.Forward;
}

/**
 * The router actions type
 */
export type RouterActions = Go | Back | Forward;
